export default {
  SELLER_ID: 'SELLER_ID',
};
